import { render, staticRenderFns } from "./StoreSummary.vue?vue&type=template&id=9345f520&scoped=true&"
import script from "./StoreSummary.vue?vue&type=script&lang=js&"
export * from "./StoreSummary.vue?vue&type=script&lang=js&"
import style0 from "./StoreSummary.vue?vue&type=style&index=0&id=9345f520&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9345f520",
  null
  
)

export default component.exports